import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = "查看更多" }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="h-7 w-1.5 rounded-full bg-primary-500" aria-hidden="true"></span>
        <div>
          <h2 className="font-heading text-2xl leading-none text-foreground-950 md:text-3xl">{title}</h2>
          {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}